export const Action = {
  play: 'play',
  pause: 'pause',
  fullscreen: 'fullscreen',
  exitFullscreen: 'exitFullscreen'
}